module.exports = __webpack_public_path__ + "static/img/userBg.1ed2dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/userBg.jpg
// module id = 0C7F
// module chunks = 0